import React, { useEffect, useState } from 'react'


import { loadTalentDocuments, loadTalentDocument, deleteTalentDocument, loadTalent } from '../utils/Network'
import { getDefaultName } from '../utils';
import TalentDocumentContent from './TalentDocumentContent';

export default function TalentDocumentsContent({ talent_id , document_id}) {

    const [loading, setLoading] = useState(0);

    const [talent, setTalent] = useState(null);
    const [talentDocuments, setTalentDocuments] = useState(null);

    useEffect(() => {
        loadTalent(talent_id).then(Talent => {
            setTalent(Talent);
            
        });

        loadTalentDocuments(talent_id).then(talentdocuments => {
            setTalentDocuments(talentdocuments);

        });


        // if(document_id){
        //     loadTalentDocument(document_id).then(talentDocument => {
        //         setTalentDocument(talentDocument);
        //     });
        // }

    }, []);


    const handleDelete = (id, e) => {
        setLoading(id);
        deleteTalentDocument(id).then(() => {
            loadTalentDocuments(talent_id).then(talentdocuments => {
                setTalentDocuments(talentdocuments);
            });;
        })
    }

    return (
        <>
            <div className="content-wrapper">
                <section className="content-header">
                    <h1>
                        {talent && getDefaultName(talent.names)} Documents
                            <small>({talentDocuments && talentDocuments.length}) items</small>
                    </h1>
                    <ol className="breadcrumb">
                        <li><a href="/cms"><i className="fa fa-dashboard"></i> Home</a></li>
                        <li ><a href="/cms/talents">Talents</a></li>
                        <li className="active">Talent Documents</li>
                    </ol>
                </section>

                <section className="content">
                    
                        <div className="row">
                            <div className="col-md-4">
                                <div className="box box-primary">
                                    <div className="box-header with-border">
                                        <h3 className="box-title">All Documents</h3>
                                    </div>
                                    <div className="box-body no-padding">
                                        <table className="table table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                <th>Name</th>
                                                <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {talentDocuments && talentDocuments.map((item) => (
                                                    <tr key={item.id} className={loading === item.id ? "loading" : ""}>
                                                        <td>
                                                        <p>{getDefaultName(item.names)}</p>
                                                            
                                                        </td>
                                                        <td className="text-right">
                                                            <div className="btn-group">
                                                                <button type="button" onClick={(e) => { if (window.confirm('Are you sure you wish to delete this item?')) handleDelete(item.id, e) }} className="btn btn-default btn-sm">
                                                                    <i className="fa fa-trash"></i>
                                                                </button>
                                                            <a href={`talents/${talent_id}/documents/${item.id}`} className="btn btn-default btn-sm">
                                                                    <i className="fa fa-edit"></i>
                                                                </a>
                                                               

                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                <th>Name</th>
                                                <th></th>
                                                </tr>
                                            </tfoot>
                                        </table>

                                    </div>


                                </div>



                            </div>
                        
                            <TalentDocumentContent talent_id={talent_id} document_id={document_id} />

                        
                        </div>
                    
                </section>

            </div>
        </>



    )
}
